import { GenIcon } from '../helpers/IconBase.es.js';

const BellOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_15304_4431)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M18.7957 11.385L17.2124 5.68829C16.7483 4.0194 15.7396 2.55353 14.3468 1.52368C12.954 0.49383 11.2569 -0.0408916 9.52525 0.00450854C7.79363 0.0499086 6.12687 0.672825 4.78992 1.77424C3.45296 2.87566 2.52253 4.39237 2.14653 6.08329L0.920696 11.5958C0.785292 12.2049 0.788423 12.8366 0.929857 13.4444C1.07129 14.0521 1.34742 14.6203 1.73785 15.1071C2.12828 15.5938 2.62305 15.9867 3.18562 16.2566C3.7482 16.5265 4.36422 16.6666 4.9882 16.6666H5.91653C6.10779 17.6085 6.6188 18.4553 7.36298 19.0636C8.10716 19.6719 9.03873 20.0041 9.99986 20.0041C10.961 20.0041 11.8926 19.6719 12.6367 19.0636C13.3809 18.4553 13.8919 17.6085 14.0832 16.6666H14.7815C15.4239 16.6667 16.0575 16.5182 16.633 16.2328C17.2085 15.9474 17.7102 15.5329 18.0989 15.0215C18.4876 14.5101 18.7528 13.9158 18.8739 13.285C18.9949 12.6541 18.9684 12.0039 18.7965 11.385H18.7957ZM9.99986 18.3333C9.48465 18.3312 8.98267 18.1699 8.56261 17.8715C8.14256 17.5732 7.82493 17.1524 7.6532 16.6666H12.3465C12.1748 17.1524 11.8572 17.5732 11.4371 17.8715C11.0171 18.1699 10.5151 18.3312 9.99986 18.3333ZM16.7715 14.0125C16.5393 14.3205 16.2385 14.5702 15.8929 14.7416C15.5473 14.913 15.1665 15.0015 14.7807 15H4.9882C4.61385 14.9999 4.2443 14.9158 3.90681 14.7538C3.56933 14.5918 3.27253 14.3561 3.03833 14.064C2.80413 13.772 2.6385 13.4311 2.55366 13.0665C2.46883 12.7019 2.46696 12.3229 2.5482 11.9575L3.7732 6.44412C4.06849 5.11596 4.79929 3.92462 5.84941 3.05949C6.89953 2.19437 8.20872 1.7051 9.56884 1.66946C10.929 1.63383 12.262 2.05388 13.356 2.86284C14.4499 3.6718 15.2421 4.82324 15.6065 6.13412L17.1899 11.8308C17.2945 12.2019 17.3111 12.5924 17.2385 12.9711C17.1659 13.3498 17.006 13.7063 16.7715 14.0125Z",
              fill: "black",
              fillOpacity: "0.88"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_15304_4431" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { BellOutlined };
